import { DataSearchResult } from "../../managers/dataManager/IDataApi";
import { logger, LOGS } from "../index";
import { optimizeMailBody } from "../textProcessing/textProcessing";

export function isSearchResultMatchKeyWords(
    dataSearchResult: DataSearchResult,
    keyWords: string[],
): boolean {
    // Early return si pas de keywords
    if (!keyWords || keyWords.length === 0) {
        logger.warn(
            LOGS.DataManager,
            "isSearchResultMatchKeyWords has no Keyword to test, should not happen ! Defaulting to true",
        );
        return true;
    }

    // Combiner subject et body en un seul texte
    // Utiliser ?? '' pour gérer les undefined/null
    const fullText = optimizeMailBody(
        [
            dataSearchResult.subject ?? "",
            dataSearchResult.uniqueBodyContent ?? "",
        ].join(" "),
    );

    // Early return si texte vide
    if (!fullText.trim()) {
        logger.warn(
            [LOGS.DataManager, LOGS.TESTS],
            "isSearchResultMatchKeyWords has no content to search on !!! Defaulting to true ...",
        );
        return true;
    }

    // Normaliser et lowercase une seule fois
    // NFC (et non NFD) : garde les caractères accentués composés (é, è, ü…)
    // NFD les décompose en lettre + combining accent, ce qui casse \b et \p{L}
    const normalizedText = fullText.toLowerCase().normalize("NFC");

    // Tester chaque keyword
    const isMatching = keyWords.some((keyword) => {
        if (!keyword) return false;

        const normalizedKeyword = keyword
            .toLowerCase()
            .normalize("NFC")
            // Échappe les métacaractères regex (. + * ? ^ $ { } ( ) | [ ] \)
            // pour qu'ils soient traités comme des littéraux et non comme des opérateurs.
            // Ex : "facture (copie)" → "facture \(copie\)", "rapport.doc" → "rapport\.doc"
            .replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

        // Construit une regex Unicode-aware pour détecter des mots entiers.
        //
        // (?<!\p{L})  : lookbehind négatif — le keyword ne doit pas être précédé d'une lettre Unicode
        // (?!\p{L})   : lookahead négatif  — le keyword ne doit pas être suivi  d'une lettre Unicode
        // Flag 'u'    : active le support des propriétés Unicode (\p{L} = toute lettre, accents inclus)
        //
        // Pourquoi pas \b : \b ne reconnaît que [a-zA-Z0-9_] comme "lettre",
        // donc il place les boundaries au mauvais endroit sur des mots accentués
        // Ex : "sécurité" → \b se positionne entre 's' et 'é' au lieu des bords du mot
        const regex = new RegExp(
            `(?<!\\p{L})${normalizedKeyword}(?!\\p{L})`,
            "u",
        );

        return regex.test(normalizedText);
    });

    return isMatching;
}
